import { render, staticRenderFns } from "./CompanyRejectDetailsModal.vue?vue&type=template&id=4f48ad46&"
import script from "./CompanyRejectDetailsModal.vue?vue&type=script&lang=js&"
export * from "./CompanyRejectDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRejectDetailsModal.vue?vue&type=style&index=0&id=4f48ad46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports